import omit from 'lodash/omit';
import {
  OBJECT_SERVER_PROPS,
  type TObjectSavePayload,
} from 'pages/objectManager/api/objectApi.types';
import { isReadOnlyField } from 'utils/fieldUtils';
import type { TField, TTEObject } from '@timeedit/types';

export const buildObjectSavePayload = (
  object: TTEObject,
  fieldMap: Record<number, TField | undefined>
): TObjectSavePayload => {
  const body = omit(object, ...OBJECT_SERVER_PROPS);
  const fields = body.fields
    // The object carries read-only reference fields whenever it was loaded with
    // `includeReferenceFields`; they must never reach a create/update payload.
    .filter((field) => !isReadOnlyField(fieldMap[field.fieldId]))
    .map((field) => ({
      ...field,
      values: field.values.filter((val) => val != null).map(String),
    }))
    .filter((field) => field.values.length > 0 && field.values[0] !== '');
  return { ...body, fields };
};
